/* globals Image */
;(function ($, window) {
  'use strict'

  window.eah = window.eah || {}

  eah.adWordsTracking = (function () {
    const defaultConversionId = '957179598'
    const defaultConversionLabel = 'sraDCOP5pVkQzs21yAM'

    function trackConv (googleConversionId, googleConversionLabel) {
      if (eah.isProduction) {
        let image = new Image(1, 1)
        image.src = '//www.googleadservices.com/pagead/conversion/' + googleConversionId + '/?label=' + googleConversionLabel + '&script=0'
      }
    }

    function fire () {
      // console.log('adWordsTracking.fire()');
      trackConv(defaultConversionId, defaultConversionLabel)
    }

    function init () {
      // console.log('eah.adWordsTracking.init()');

      $('a[data-track-conversion]').on('click', function () {
        fire()
      })

      $(document).on('submitResponse.tracking', function (e, formData, jqForm, options) {
        // console.log('response submitted', e, formData, jqForm, options);
        if (formData && formData.success && !formData.errors) {
          fire()
        }
        return true
      })

      $('form .ninja-forms-field.button').on('click', function (e) {
        // $(this).closest('.open.form').css('top', 0);
        // fire();
      })
    }

    return {
      initialize: init,
      fire: fire

    }
  }())

  jQuery(window).on('load', function () {
    // load this module only on the live site
    if (window.location.host === 'www.eahomes.com') {
      eah.adWordsTracking.initialize()
    }
  })
}(jQuery, window))
